import shared from '~/shared.js';
import * as React from 'react';
export default {
  shared,
  React
};